/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import {StyledCard} from '../../../components/StyledCard'
import * as TableUI from '../../../components/Table/Table'
import {useRowTable} from '../../../hooks/useRowTable'
import Pagination from '../component/Pagination'
import {RowData} from './RowData'
import {RowFilter} from './RowFilter'
import {RowHead} from './RowHead'
import {useTableDo} from './useTableDo'
import {ButtonGroups} from './ButtonGroups'
import { ModalSync } from './ModalSync'

type Props = {
  className: string
}

const TableDo: React.FC<Props> = ({className}) => {
  const {
    // eslint-disable-line
    tableData,
    rowNumber,
    numberURL,
    loading,
    isError,
    paginateNumber,
    onReloadTable,
  } = useTableDo()

  const role: any = localStorage.getItem('role-flag')

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({colSpan: 12, onReloadTable})
  const [showSync, setShowSync] = useState(false)
  const [isLoadingSync, setIsLoadingSync] = useState(false)

  return <>
    <StyledCard>
      <ButtonGroups hasSync={[
        'salesAdmin', 'admin'
      ].includes(role)}
      setShowSync={setShowSync}
      isLoadingSync={isLoadingSync}/>

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <RowHead />
          </TableUI.THead>

          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : tableData.length === 0 ? (
              <RowEmptyData />
            ) : (
              <RowData items={tableData} rowNumber={rowNumber} />
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />
    </StyledCard>

    <ModalSync showSync={showSync} setShowSync={setShowSync} isLoadingSync={isLoadingSync} setIsLoadingSync={setIsLoadingSync}/>
  </>
}

export {TableDo}
